import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getWarehouseStockApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getWarehouseStockListApi = createAsyncThunk('getWarehouseStockList', async (payload) => {
  return await getWarehouseStockApi(payload);
});

const getWarehouseStockListSlice = createSlice({
  name: 'getWarehouseStockList', // Unique Name
  initialState,
  reducers: {
    getWarehouseStockListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouseStockListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getWarehouseStockListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getWarehouseStockListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getWarehouseStockListReset } = getWarehouseStockListSlice.actions;

export default getWarehouseStockListSlice.reducer;
